interface Plan {
  id: string;
  name: string;
  credits_per_period: number;
  price_monthly_cents: number;
  price_yearly_cents: number;
  stripe_price_id_monthly?: string;
  stripe_price_id_yearly?: string;
}

interface SubscriptionPlansProps {
  plans: Plan[];
  currentSubscription: any;
  onSelectPlan: (priceId: string, type: 'subscription') => void;
}

export default function SubscriptionPlans({
  plans,
  currentSubscription,
  onSelectPlan,
}: SubscriptionPlansProps) {
  const formatPrice = (cents: number) => {
    return `$${(cents / 100).toFixed(2)}`;
  };

  const isCurrentPlan = (plan: Plan) => {
    if (!currentSubscription) return false;
    // Don't show as current plan if subscription is canceled
    if (currentSubscription.status === 'canceled') return false;
    return currentSubscription.plan_id === plan.id;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {plans
        .filter((plan) => plan.name !== 'Free') // Exclude free plan from paid plans
        .map((plan) => (
          <div
            key={plan.id}
            className={`glass-card rounded-xl p-6 ${
              isCurrentPlan(plan)
                ? 'ring-2 ring-primary-600 dark:ring-primary-400'
                : ''
            }`}
          >
            <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              {plan.name}
            </h4>
            <div className="mb-4">
              <p className="text-3xl font-bold text-gray-900 dark:text-white">
                {plan.credits_per_period.toLocaleString()}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400">credits per period</p>
            </div>
            <div className="mb-6 space-y-2">
              {plan.stripe_price_id_monthly && (
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600 dark:text-gray-400">Monthly</span>
                  <span className="font-semibold text-gray-900 dark:text-white">
                    {formatPrice(plan.price_monthly_cents)}
                  </span>
                </div>
              )}
              {plan.stripe_price_id_yearly && (
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600 dark:text-gray-400">Yearly</span>
                  <span className="font-semibold text-gray-900 dark:text-white">
                    {formatPrice(plan.price_yearly_cents)}
                  </span>
                </div>
              )}
            </div>
            {isCurrentPlan(plan) ? (
              <button
                disabled
                className="w-full px-4 py-2 bg-gray-300 dark:bg-slate-700 text-gray-600 dark:text-gray-400 rounded-lg cursor-not-allowed"
              >
                Current Plan
              </button>
            ) : (
              <div className="space-y-2">
                {plan.stripe_price_id_monthly && (
                  <button
                    onClick={() => onSelectPlan(plan.stripe_price_id_monthly!, 'subscription')}
                    className="w-full px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition"
                  >
                    Subscribe Monthly
                  </button>
                )}
                {plan.stripe_price_id_yearly && (
                  <button
                    onClick={() => onSelectPlan(plan.stripe_price_id_yearly!, 'subscription')}
                    className="w-full px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition"
                  >
                    Subscribe Yearly
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
    </div>
  );
}

